export default function ClientsDot({ active }) {
  return (
    <div
      className={`w-[12px] aspect-square duration-500 ${
        active ? " bg-primaryBlue scale-125" : " bg-lightBlue"
      } rounded-full`}
    ></div>
  );
}
